import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';

export default function DeactivatePatientDialog({ open, patientName, onCancel, onConfirm }) {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogTitle>Desativar paciente</DialogTitle>
      <DialogContent dividers>
        <Typography>
          O paciente {patientName ? `"${patientName}"` : 'selecionado'} será desativado. Deseja
          continuar?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Cancelar</Button>
        <Button variant="contained" color="error" onClick={onConfirm}>
          Desativar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

DeactivatePatientDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  patientName: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

DeactivatePatientDialog.defaultProps = {
  patientName: '',
};
